import contentLoaded from './vendor/contentloaded.min.js'
import './vendor/jquery.viewportchecker.min.js'
import validate from './vendor/jquery.validate.min.js'
// import wistia from './wistia.js'
import images from './images.js'
// import multistep from './multi-step-form.js'
import phoneConcat from './phone-concatination.js'
import polyfill from './polyfills.js'
import sliders from './sliders.js'
import smoothScroll from './smooth-scroll.js'
import stickyHeader from './sticky-header.js'
import timer from './timer.js'
import videos from './video-embeds.js'
import viewAnimation from './view-animation.js'
import getCurrentMonth from './month.js'
import Fancybox from './fancybox.js'
import popUp from './popup.js'
// import unlockPage from './unlockPage.js'
import thankyouMessage from './thank-you-message.js'

contentLoaded()

//easing()
//validate()

window.contentLoaded(window, function (e) {
	polyfill()
	phoneConcat()
	images()
	getCurrentMonth()
	sliders()
	smoothScroll()
	stickyHeader()
	videos()
	viewAnimation()
	getCurrentMonth()
	Fancybox()
	popUp()
	timer()
	thankyouMessage()
	// wistia()
	// multistep();
})
